/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Box_Label_Sender_PhoneInputs */

const vi_box_label_sender_phone = /** @type {(inputs: Box_Label_Sender_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SĐT`)
};

/**

* @param {Box_Label_Sender_PhoneInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const box_label_sender_phone = /** @type {((inputs?: Box_Label_Sender_PhoneInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Box_Label_Sender_PhoneInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_box_label_sender_phone(inputs)
});